import Vue from 'vue';
import _ from 'lodash';

import apiFactory from '@/api/default';
const API = apiFactory('devices');
const statusAPI = apiFactory('status');

import productsHelper from '@/helpers/products.helper';

const state = {
  deviceSearchResults: [],
  currentDevice: {},
};

const getters = {
  deviceSearchResults: (state) => state.deviceSearchResults,
  currentDevice: (state) => state.currentDevice,
};

const mutations = {
  setDeviceSearchResults: (state, deviceSearchResults) => {
    state.deviceSearchResults = deviceSearchResults;
  },
  updateDeviceSearchResults: (state, task) => {
    const index = state.deviceSearchResults.findIndex((el)=>el._id === task._id);
    if (index >= 0) Vue.set(state.deviceSearchResults, index, task);
  },
  addToDeviceSearchResults: (state, item) => {
    state.deviceSearchResults.unshift(item);
  },
  removeFromDeviceSearchResults: (state, id)=>{
    state.deviceSearchResults.data = state.deviceSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.deviceSearchResults.total--;
  },
  setCurrentDevice: (state, currentDevice) => {
    const device = currentDevice;
    // When we set new device we need to add the charts as apps property with a property saved
    // So later we will know that this chart is created because both the charts and the apps may have an _id property
    // because both of them come from the database
    if (device.charts?.length) {
      const {charts} = device;
      charts.forEach((chart) => (chart.saved = true));
      device.apps = charts;
    } else {
      device.apps = [];
    }
    state.currentDevice = device;
  },
  updateCurrentDeviceProperties: (state, properties) => {
    for (const key in properties) {
      if (Object.prototype.hasOwnProperty.call(properties, key)) {
        Vue.set(state.currentDevice, key, properties[key]);
      }
    }
  },
};

const actions = {

  async searchDevices({commit}, data) {
    const response = await API.search(data.query);
    commit('setDeviceSearchResults', response.data);
    return response.data;
  },
  async loadDevice({commit}, data) {
    const response = await API.load(data.id, data.query);
    commit('setCurrentDevice', response.data);
    return response.data;
  },
  async createDevice({commit}, data) {
    const response = await API.create(data);
    commit('addToDeviceSearchResults', response.data);
    return response.data;
  },
  async updateDevice({commit}, payload) {
    const response = await API.update(payload.id, payload.props);
    commit('updateDeviceSearchResults', response.data);
    return response.data;
  },
  /**
   * Update currentDevice with populated props, de-populate them and updated the device in the DB
   *
   * @param {*} store - The Vuex store
   * @param {*} payload - object, supplied when calling this action
   * @property {string} [payload.id] - the _id of the device to be updated
   * @property {*} payload.props - properties to de-populate and save
   * @return {*} - server response
   */
  async updateDeviceProperty(store, payload) {
    const {id, props} = payload;
    const {getters, commit} = store;
    const populatedProperties = _.cloneDeep(props);
    // de-populate props
    for (const key of Object.keys(props)) {
      // We are using the function from the product helper. It does not care if the supplied prop is from product
      // or from device
      productsHelper.dePopulateProperty(props, key);
    }
    // Supplied id takes precedence
    let deviceId = undefined;
    if (id) {
      deviceId = id;
    } else if (getters.currentDevice._id) {
      deviceId = getters.currentDevice._id;
    } else {
      // No need to translate this since it is for developers eyes only!
      throw new Error('No id supplied and currentDevice is not loaded');
    }
    const response = await API.update(deviceId, props);
    // If the update is successful update currentDevice with populated props
    commit('updateCurrentDeviceProperties', populatedProperties);
    // Re set the current device so the apps property is filled properly
    commit('setCurrentDevice', getters.currentDevice);
    return response.data;
  },
  async deleteDevice({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromDeviceSearchResults', id);
    return response;
  },
  async getDeviceStatus({commit}, data) {
    const response = await statusAPI.load(data.id, data.query);
    return response.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
